import React, { useEffect } from "react";
import loadable from "@loadable/component";
import { Route, Routes, useLocation } from "react-router-dom";
import Logo from "./images/whitebg.jpg";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import ScrollToTop from "react-scroll-to-top";
import Appwrap from "./components/global/appwrap";
import Homepage from "./components/homepage/index";
import Popupform from "../src/components/global/popupform";
import Loader from "../src/components/global/loader"; // fallback loader

// Using @loadable/component for all heavy pages
const Aboutpage = loadable(() => import("./components/aboutus/index"), {
  fallback: <Loader />,
});
const Services = loadable(() => import("./components/services/index"), {
  fallback: <Loader />,
});
const Contact = loadable(() => import("./components/contact/index"), {
  fallback: <Loader />,
});
const Blog = loadable(() => import("./components/blogpage/blog"), {
  fallback: <Loader />,
});
const Blog1 = loadable(() => import("./components/blogpages/blog1"), {
  fallback: <Loader />,
});
const Blog7 = loadable(
  () =>
    import(
      "./components/blogpages/Plots in Chikka Madure, Nelamangala Bengaluru"
    ),
  { fallback: <Loader /> }
);
const Blog8 = loadable(
  () =>
    import(
      "./components/blogpages/Real Estate Agents in Rajajinagar Bengaluru"
    ),
  { fallback: <Loader /> }
);
const Blog9 = loadable(() => import("./components/blogpages/blog2"), {
  fallback: <Loader />,
});
const Blog10 = loadable(() => import("./components/blogpages/blog3"), {
  fallback: <Loader />,
});
const Blog11 = loadable(
  () => import("./components/blogpages/plots for sale in nelamangala"),
  { fallback: <Loader /> }
);
const Blog12 = loadable(() => import("./components/blogpages/blog4"), {
  fallback: <Loader />,
});
const Blog13 = loadable(() => import("./components/blogpages/blog5"), {
  fallback: <Loader />,
});
const Blog14 = loadable(() => import("./components/blogpages/blog6"), {
  fallback: <Loader />,
});
const Blog15 = loadable(() => import("./components/blogpages/blog7"), {
  fallback: <Loader />,
});
const Blog16 = loadable(() => import("./components/blogpages/blog8"), {
  fallback: <Loader />,
});
const Blog17 = loadable(() => import("./components/blogpages/blog9"), {
  fallback: <Loader />,
});
const Blog18 = loadable(() => import("./components/blogpages/blog10"), {
  fallback: <Loader />,
});
const Blog19 = loadable(() => import("./components/blogpages/blog11"), {
  fallback: <Loader />,
});
const Blog20 = loadable(() => import("./components/blogpages/blog12"), {
  fallback: <Loader />,
});
const Blog21 = loadable(() => import("./components/blogpages/blog13"), {
  fallback: <Loader />,
});
const Blog22 = loadable(() => import("./components/blogpages/blog14"), {
  fallback: <Loader />,
});
const Blog23 = loadable(() => import("./components/blogpages/blog15"), {
  fallback: <Loader />,
});
const Blog24 = loadable(() => import("./components/blogpages/blog16"), {
  fallback: <Loader />,
});
const Blog25 = loadable(() => import("./components/blogpages/blog17"), {
  fallback: <Loader />,
});
const Blog26 = loadable(() => import("./components/blogpages/blog18"), {
  fallback: <Loader />,
});
const Blog27 = loadable(() => import("./components/blogpages/blog19"), {
  fallback: <Loader />,
});
const Blog28 = loadable(() => import("./components/blogpages/blog20"), {
  fallback: <Loader />,
});
const Blog29 = loadable(() => import("./components/blogpages/blog21"), {
  fallback: <Loader />,
});
const Blog30 = loadable(() => import("./components/blogpages/blog22"), {
  fallback: <Loader />,
});
const Blog31 = loadable(() => import("./components/blogpages/blog23"), {
  fallback: <Loader />,
});
const Bmrda = loadable(() => import("./components/bmrda/bmrda"), {
  fallback: <Loader />,
});
const Bmrda1 = loadable(() => import("./components/bmrda/bmrda2"), {
  fallback: <Loader />,
});

// farm land blogs//////////////////////////////////////////////

const Farmblogs = loadable(
  () => import("../src/components/farm blogs/farmblogs"),
  {
    fallback: <Loader />,
  }
);

// farm land blogs con//////////////////////////////////////////////
const Farmblog1 = loadable(
  () => import("../src/components/farm blogs/farmblog1"),
  {
    fallback: <Loader />,
  }
);

const Farmblog2 = loadable(
  () => import("../src/components/farm blogs/farmblog2"),
  {
    fallback: <Loader />,
  }
);

const Farmblog3 = loadable(
  () => import("../src/components/farm blogs/farmblog3"),
  {
    fallback: <Loader />,
  }
);

const Farmblog4 = loadable(
  () => import("../src/components/farm blogs/farmblog4"),
  {
    fallback: <Loader />,
  }
);

const Farmblog5 = loadable(
  () => import("../src/components/farm blogs/farmblog5"),
  {
    fallback: <Loader />,
  }
);

const Farmblog6 = loadable(
  () => import("../src/components/farm blogs/farmblog6"),
  {
    fallback: <Loader />,
  }
);

const Farmblog7 = loadable(
  () => import("../src/components/farm blogs/farmblog7"),
  {
    fallback: <Loader />,
  }
);

const Farmblog8 = loadable(
  () => import("../src/components/farm blogs/farmblog8"),
  {
    fallback: <Loader />,
  }
);

const Farmblog9 = loadable(
  () => import("../src/components/farm blogs/farmblog9"),
  {
    fallback: <Loader />,
  }
);

const Farmblog10 = loadable(
  () => import("../src/components/farm blogs/farmblog10"),
  {
    fallback: <Loader />,
  }
);

const Farmblog11 = loadable(
  () => import("../src/components/farm blogs/farmblog11"),
  {
    fallback: <Loader />,
  }
);

const Farmblog12 = loadable(
  () => import("../src/components/farm blogs/farmblog12"),
  {
    fallback: <Loader />,
  }
);

const Farmblog13 = loadable(
  () => import("../src/components/farm blogs/farmblog13"),
  {
    fallback: <Loader />,
  }
);

const Farmblog14 = loadable(
  () => import("../src/components/farm blogs/farmblog14"),
  {
    fallback: <Loader />,
  }
);

const Farmblog15 = loadable(
  () => import("../src/components/farm blogs/farmblog15"),
  {
    fallback: <Loader />,
  }
);

const Farmblog16 = loadable(
  () => import("../src/components/farm blogs/farmblog16"),
  {
    fallback: <Loader />,
  }
);
const StickySocials = loadable(
  () => import("../src/components/global/syticky"),
  { fallback: <Loader /> }
);
const Gallery = loadable(() => import("./components/portfolio/section2"), {
  fallback: <Loader />,
});
const Bank = loadable(() => import("./components/homepage/bank"), {
  fallback: <Loader />,
});
const Testimonials = loadable(
  () => import("./components/homepage/testinomial"),
  { fallback: <Loader /> }
);
const ThankYou = loadable(() => import("./components/thankyou/thankyou"), {
  fallback: <Loader />,
});

export default function App() {
  const location = useLocation();

  useEffect(() => {
    document.addEventListener("mousemove", (e) => {
      const cursor = document.querySelector(".custom-cursor");
      if (cursor?.style) {
        cursor.style.left = `${e.pageX}px`;
        cursor.style.top = `${e.pageY}px`;
      }
    });

    document.querySelectorAll("a, button, img").forEach((element) => {
      element.addEventListener("mouseenter", () => {
        document.querySelector(".custom-cursor")?.classList.add("hover");
      });
      element.addEventListener("mouseleave", () => {
        document.querySelector(".custom-cursor")?.classList.remove("hover");
      });
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="bg-white relative">
      {/* ✅ WhatsApp Floating Button */}
      <FloatingWhatsApp
        phoneNumber="+91-9845751751"
        accountName="Urban Nest Properties"
        avatar={Logo}
        width="58px"
        height="58px"
        statusMessage="Typically replies in 5 min"
        chatMessage="Hello! How can we assist you today?"
        allowEsc
        allowClickAway
        notification
        notificationSound
      />

      {/* ✅ Scroll to Top */}
      <ScrollToTop smooth className="mb-16 pl-2" color="red" />

      <Appwrap>
        <div className="md:block"><Popupform /></div>
        <div className="hidden md:block lg:block">
          <StickySocials />
        </div>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/aboutus" element={<Aboutpage />} />
          <Route path="/ourservices" element={<Services />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contactus" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog1" element={<Blog1 />} />
          <Route
            path="/Plots-in-Chikka-Madure-Nelamangala-Bengaluru"
            element={<Blog7 />}
          />
          <Route
            path="/Real-Estate-Agents-in-Rajajinagar-Bengaluru"
            element={<Blog8 />}
          />
          <Route
            path="/Gated-Community-Plots-clear-Tiles"
            element={<Blog9 />}
          />
          <Route path="/Looking-for-Investors" element={<Blog10 />} />
          <Route path="/plots-for-sale-in-nelamangala" element={<Blog11 />} />
          <Route
            path="/plots-in-doddaballapur-bengaluru"
            element={<Blog12 />}
          />
          <Route
            path="/top-real-estate-builders-in-bengaluru"
            element={<Blog13 />}
          />
          <Route
            path="/land-for-sale-in-chikka-madure-bengaluru"
            element={<Blog14 />}
          />
          <Route
            path="/Real-Esate-Company-Near-Me-Buy-Plots-in-Bengaluru"
            element={<Blog15 />}
          />
          <Route
            path="/Prime-Real-Estate-Location-Near-NH-75-Farm-&Investment-Plots-Near-Bangalore"
            element={<Blog16 />}
          />
          <Route
            path="/real-estate-agents-rajajinagar-bangalore"
            element={<Blog17 />}
          />
          <Route
            path="/Gated-Community-Plots-Near-Nelamangala-BMRDA-E-Khata-Plots-for-Sale"
            element={<Blog18 />}
          />
          <Route
            path="/BMRDA-Approved-Sites-Near-Me-Verified-Plots-with-E-Khata-Urban-Nest"
            element={<Blog19 />}
          />
          <Route
            path="/top-real-estate-companies-in-bangalore"
            element={<Blog20 />}
          />
          <Route path="/real-estate-agency-bangalore" element={<Blog21 />} />
          <Route path="/residential-plots-in-bangalore" element={<Blog22 />} />
          <Route
            path="/bmrda-approved-plots-in-bangalore"
            element={<Blog23 />}
          />
          <Route path="/site-for-sale-in-bengaluru" element={<Blog24 />} />
          <Route
            path="/e-khata-plots-for-sale-in-bengaluru"
            element={<Blog25 />}
          />
          <Route
            path="/land-rates-in-bangalore-per-square-feet"
            element={<Blog26 />}
          />
          <Route
            path="/land-rate-in-nelamangala-bangalore"
            element={<Blog27 />}
          />
          <Route
            path="/farm-villas-near-nelamangala-bangalore"
            element={<Blog28 />}
          />
          <Route
            path="/farm-house-for-sale-near-nelamangala-with-price."
            element={<Blog29 />}
          />
          <Route
            path="/agriculture-land-for-sale-near-dabaspet"
            element={<Blog30 />}
          />
      
          {/* farmblogsssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssss */}
          <Route path="/farmblogs" element={<Farmblogs />} />
          <Route
            path="/Farm-Land-for-Sale-Near-Bangalore-Managed-Farmland-&-BMRDA-Approved-Plots"
            element={<Farmblog1 />}
          />
          <Route
            path="/Farmland-Investment-Near-Bangalore-Agriculture-&-Managed-Farmland-for-Sale"
            element={<Farmblog2 />}
          />
          <Route
            path="/Agriculture-Land-for-Sale-Near-Bangalore-1-Acre-Farmland-in-Devanahalli-Doddaballapur"
            element={<Farmblog3 />}
          />
          <Route
            path="/Farm-Houses-for-Sale-Near-Bangalore–Affordable-Farmland-&-Managed-Investment-Opportunities"
            element={<Farmblog4 />}
          />
          <Route
            path="/Farm-Land-Near-Doddaballapur-Managed-Farmland-&-Weekend-Farm-Houses"
            element={<Farmblog5 />}
          />
          <Route
            path="/Farm-Land-for-Sale-Near-Me-Agriculture-Land-in-Nelamangala,-Doddaballapur-&-Devanahalli"
            element={<Farmblog6 />}
          />
          <Route
            path="/Agriculture-Land-for-Commercial-Farming-Managed-Farmland-in-Nelamangala-&-Devanahalli"
            element={<Farmblog7 />}
          />
          <Route
            path="/5.5-Gunta-Farm-Plot-in-Nelamangala-BMRDA-Approved-Farmland-Near-Bangalore"
            element={<Farmblog8 />}
          />
          <Route
            path="/BMRDA-Approved-Farm-Plots-in-Nelamangala-E-Khata-&-Farmhouses"
            element={<Farmblog9 />}
          />
          <Route
            path="/Managed-Farmland-Near-Nelamangala-Farm-Land-for-Sale-Near-Bangalore"
            element={<Farmblog10 />}
          />
          <Route
            path="/Organic-Farm-Land-for-Sale-Near-Bangalore-Top-Real-Estate-Company"
            element={<Farmblog11 />}
          />
          <Route
            path="/Farm-Land-for-Sale-Near-Nelamangala-BMRDA-Approed-Farmland"
            element={<Farmblog12 />}
          />
          <Route
            path="/Agricultural-Land-for-Sale-with-Clear-Title-Managed-&-Organic-Plots-Bangalore"
            element={<Farmblog13 />}
          />
          <Route
            path="/Profitable-Investment-in-Agricultural-Land–Bangalore’s-Prime-Farm Plots"
            element={<Farmblog14 />}
          />
          <Route
            path="/Luxury-Farmhouses-in-Bangalore-Premium-Managed-Farmland-for-Investment"
            element={<Farmblog15 />}
          />
          <Route
            path="/BMRDA-Approved-Plots-&-Farm-Land-for-Sale-Best-Real-Estate-Company-in-Bangalore-Urban-Nest-Properties"
            element={<Farmblog16 />}
          />

          {/* farmblogsssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssss */}

          <Route path="/30x40-site-price-bengaluru" element={<Blog31 />} />

          <Route path="/bmrda" element={<Bmrda />} />
          <Route path="/bmrda1" element={<Bmrda1 />} />
          <Route path="/bank" element={<Bank />} />
          <Route path="/testinomial" element={<Testimonials />} />
          <Route path="/thank-you" element={<ThankYou />} />
        </Routes>
      </Appwrap>
    </div>
  );
}
